import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, HelpCircleIcon } from 'lucide-react';
export function PricingSection() {
  return <section className="py-16 md:py-24 bg-stone-100" id="comprar" data-id="element-62">
      <div className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-63">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-64">
          <div className="bg-teal-900 p-8 md:p-12 text-center text-white" data-id="element-65">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-66">
              Recupera el control de tu metabolismo hoy mismo
            </h2>
            <p className="text-lg md:text-xl text-teal-100 max-w-2xl mx-auto" data-id="element-67">
              No permitas que el estrés dicte cómo te ves y cómo te sientes. El
              Protocolo de Reinicio de Cortisol está disponible ahora por un
              pago único.
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-68">
            <div className="mb-8" data-id="element-69">
              <div className="inline-flex items-center bg-red-100 border border-red-200 text-red-700 font-bold px-4 py-2 rounded-full text-sm mb-4 animate-pulse" data-id="element-70">
                <span className="relative flex h-2.5 w-2.5 mr-2" data-id="element-71">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-72"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-73"></span>
                </span>
                ¡Solo quedan 7 copias a este precio!
              </div>
              <p className="text-gray-500 font-medium uppercase tracking-wide text-sm mb-2" data-id="element-74">
                Precio Normal
              </p>
              <p className="text-2xl text-gray-400 line-through decoration-red-500 decoration-2 font-bold mb-2" data-id="element-75">
                $49.99 USD
              </p>

              <div className="inline-block bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold text-sm mb-6" data-id="element-76">
                AHORRAS $40.00 USD
              </div>

              <p className="text-gray-900 font-medium mb-1" data-id="element-77">
                Precio Especial de Lanzamiento:
              </p>
              <div className="flex items-center justify-center items-baseline space-x-2" data-id="element-78">
                <span className="text-6xl md:text-7xl font-extrabold text-gray-900" data-id="element-79">
                  $9.99
                </span>
                <span className="text-xl text-gray-500 font-medium" data-id="element-80">USD</span>
              </div>
            </div>

            <div className="max-w-md mx-auto" data-id="element-81">
              <CTAButton className="w-full text-xl py-5" isFinalBuy={true} data-id="element-82" />

              <div className="mt-6 flex items-center justify-center text-sm text-gray-500 space-x-2" data-id="element-83">
                <ShieldCheckIcon className="h-5 w-5 text-green-500" data-id="element-84" />
                <span data-id="element-85">Pago 100% seguro y descarga inmediata</span>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="mt-20" data-id="element-86">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-10 flex items-center justify-center" data-id="element-87">
            <HelpCircleIcon className="h-6 w-6 mr-2 text-teal-600" data-id="element-88" />
            Preguntas Frecuentes
          </h3>

          <div className="space-y-6 max-w-3xl mx-auto" data-id="element-89">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-90">
              <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-91">
                ¿Necesito equipo especial?
              </h4>
              <p className="text-gray-600" data-id="element-92">
                No, solo tus manos y 5 minutos. Puedes hacer el protocolo desde
                la comodidad de tu cama.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-93">
              <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-94">
                ¿Es una dieta estricta?
              </h4>
              <p className="text-gray-600" data-id="element-95">
                No. Es un ajuste químico de lo que ya comes para calmar tus
                hormonas. No pasarás hambre ni contarás calorías.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-96">
              <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-97">
                ¿Cuándo recibo el producto?
              </h4>
              <p className="text-gray-600" data-id="element-98">
                Tendrás acceso inmediato en PDF justo después de completar tu
                compra segura.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}